module.exports = __webpack_public_path__ + "media/images/mapGreen-6a03a7654c4e96cef49a6a554f20e3a3.svg";